import '.j{display:grid;}.ssr-plugin'
import { TeamMember, TeamCard } from '@app/components/blocks/card/TeamCard'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'
import BrianImage from '@app/assets/images/steward-ownership/stewards/Brian.jpg'
import AnneImage from '@app/assets/images/steward-ownership/stewards/Anne.jpg'
import LisanneImage from '@app/assets/images/steward-ownership/stewards/Lisanne.jpg'
import LisetteImage from '@app/assets/images/steward-ownership/stewards/Lisette.jpg'
import MichielImage from '@app/assets/images/steward-ownership/stewards/Michiel.jpg'
import SaschaImage from '@app/assets/images/steward-ownership/stewards/Sascha.jpg'
import TjeerdImage from '@app/assets/images/steward-ownership/stewards/Tjeerd.jpg'

const stewards: TeamMember[] = [
  {
    name: 'Anne van der Wiel',
    role: 'Independent steward',
    image: AnneImage,
    linkedIn: 'https://www.linkedin.com/in/annegreetvanderwiel/',
  },
  {
    name: 'Brian Garret',
    role: 'Founder steward',
    image: BrianImage,
    linkedIn: 'https://www.linkedin.com/in/briangarret',
  },
  {
    name: 'Lisanne Barnaart',
    role: 'Employee steward',
    image: LisanneImage,
    linkedIn: 'https://www.linkedin.com/in/lisannebarnaart/',
  },
  {
    name: 'Lisette Schuitemaker',
    role: 'Investor steward',
    image: LisetteImage,
    linkedIn: 'https://www.linkedin.com/in/lisette-schuitemaker-77a488/',
  },
  {
    name: 'Michiel Voskamp',
    role: 'Employee steward',
    image: MichielImage,
    linkedIn: 'https://www.linkedin.com/in/michiel-voskamp-abc/',
  },
  {
    name: 'Sascha Glasl',
    role: 'Founder steward',
    image: SaschaImage,
    linkedIn: 'https://www.linkedin.com/in/saschaglasl/',
  },
  {
    name: 'Tjeerd Haccou',
    role: 'Founder steward',
    image: TjeerdImage,
    linkedIn: 'https://www.linkedin.com/in/tjeerd-haccou/',
  },
]

export const OurStewards = () => {
  const isMobile = useMediaQuery()

  return (
    <div className="j"
      style={{
        gap: isMobile ? '0.5rem' : '1.5rem',
        gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',
      }}
    >
      {stewards.map((steward, index) => (
        <TeamCard key={index} {...steward} />
      ))}
    </div>
  )
}
